import { VenueCategoryUnionType } from '@api';
import { SelectField, TextField } from '@hypeit-gmbh/hypeit-ui';
import { Fieldset, Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { TagsInputField } from './components';

const TRANS_KEY = 'VENUE_FORM.BASE_INFORMATION';

type BaseInformationFieldsPropsType = {
  venueCategories: VenueCategoryUnionType[];
};

export const BaseInformationFields: React.FC<
  BaseInformationFieldsPropsType
> = ({ venueCategories }) => {
  const { t } = useTranslation('venues');

  const categoryOptions = venueCategories.map((category) => ({
    label: t(`CATEGORIES.${category}`),
    value: category,
  }));

  return (
    <Fieldset legend={t(`${TRANS_KEY}.BASE_INFORMATION_LABEL`)}>
      <Grid>
        <Grid.Col span={6}>
          <TextField
            fieldName="name"
            label={t(`${TRANS_KEY}.NAME_LABEL`)}
            required
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextField
            fieldName="shortName"
            label={t(`${TRANS_KEY}.SHORT_NAME_LABEL`)}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TagsInputField
            label={t(`${TRANS_KEY}.VENUE_PROMOTER_ID_LABEL`)}
            placeholder={t(`${TRANS_KEY}.VENUE_PROMOTER_ID_PLACEHOLDER`)}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <SelectField
            fieldName="category"
            label={t(`${TRANS_KEY}.CATEGORY_LABEL`)}
            required
            data={categoryOptions}
            allowDeselect={false}
            searchable
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <TextField
            fieldName="website"
            label={t(`${TRANS_KEY}.WEBSITE_LABEL`)}
          />
        </Grid.Col>
      </Grid>
    </Fieldset>
  );
};
